import React from 'react';
import { getTirePrice } from 'utils/price';

export default ({ cart, catalogs, mappings }) => {
  const grouped = {};
  Object.keys(cart).forEach(id => {
    const qty = cart[id];
    if (!qty) return;
    const mapping = mappings.find(i => i.id === id);
    const { catalogId, product_pos_code, images } = mapping;
    const products = catalogs.find(c => c.cat_id === mapping.catalogId).products;
    if (products) {
      const groupId = catalogId + product_pos_code;
      const prod = products.find(
        p => p.pos_code === mapping.product_pos_code
      );
      const group = (grouped[groupId] = grouped[groupId] || {
        qty: 0,
        price: 0,
        total: 0,
        size: prod.size
      });
      group.qty = (group.qty + (qty * images.length*mapping.quantity));
      group.price = getTirePrice(prod.price, group.qty);
      group.total = group.price * group.qty;
    }
  });

  const rows = Object.keys(grouped).map(id => {
    const group = grouped[id];
    return (
      <tr key={id}>
        <td>{group.size}</td>
        <td>{group.qty}</td>
        <td>${group.price.toFixed(2)}</td>
        <td>${group.total.toFixed(2)}</td>
      </tr>
    );
  });

  return (
    <div>
      <h4>Order Summary ({Object.keys(cart).length} Mappings):</h4>
      <table className="order-summary-table">
        <thead>
        <tr>
          <th>Size</th>
          <th>Qty</th>
          <th>Price</th>
          <th>Total</th>
        </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
    </div>
  );
};
